var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col"},[_c('div',{staticClass:"md:w-1/3 sm:w-full p-tiny"},[_c('label',{staticClass:"label-control",attrs:{"for":"grid-template"}},[_vm._v("Template")]),_c('v-select',{staticClass:"text-xs bg-white",attrs:{"options":_vm.templates,"reduce":function (temp) { return temp.tempID; },"label":"tempName"},model:{value:(_vm.templateID),callback:function ($$v) {_vm.templateID=$$v},expression:"templateID"}})],1),_c('div',{staticClass:"w-full p-tiny"},[_c('ejs-richtexteditor',{ref:"historyOfIllnessRTE",attrs:{"disabled":_vm.$root.formatLowercase(_vm.$root.username) ==
          _vm.$root.formatLowercase(_vm.notes.userName) ||
        _vm.$root.checkAuth('AdminEditMedicalFile')
          ? false
          : true,"height":260,"insertImageSettings":{ saveFormat: 'Base64' },"toolbarSettings":{
        items: [
          'Bold',
          'Italic',
          'Underline',
          'StrikeThrough',
          'FontName',
          'FontSize',
          'FontColor',
          'BackgroundColor',
          'LowerCase',
          'UpperCase',
          'SuperScript',
          'SubScript',
          '|',
          'Formats',
          'Alignments',
          'OrderedList',
          'UnorderedList',
          'Outdent',
          'Indent',
          '|',
          'CreateTable',
          'CreateLink',
          'Image',
          '|',
          'ClearFormat',
          'Print',
          'SourceCode',
          'FullScreen',
          '|',
          'Undo',
          'Redo' ],
      }},model:{value:(_vm.notes.historyofIllness),callback:function ($$v) {_vm.$set(_vm.notes, "historyofIllness", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"notes.historyofIllness"}})],1),_c('div',{staticClass:"w-full text-right p-tiny"},[(
        _vm.$root.formatLowercase(_vm.$root.username) ==
          _vm.$root.formatLowercase(_vm.notes.userName) ||
          _vm.$root.checkAuth('AdminEditMedicalFile')
      )?_c('button',{staticClass:"btn-sm text-sm btn-primary rounded",on:{"click":function($event){$event.preventDefault();return _vm.saveData.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Save ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }